import type { StatusPedido } from './types';

export const STATUS_PEDIDO_CONFIG: Record<
  StatusPedido,
  { label: string; classes: string }
> = {
  pago: { label: 'Pago', classes: 'bg-accent-100 text-accent-900' },
  aguardando: { label: 'Aguardando pagamento', classes: 'bg-amber-100 text-amber-800' },
  cancelado: { label: 'Cancelado', classes: 'bg-danger-100 text-danger-700' },
  expirado: { label: 'Expirado', classes: 'bg-secondary-100 text-secondary-700' },
};

// Código curto exibido no ingresso (ex.: A1B2C3D4).
export function codigoCurto(uuid: string): string {
  return uuid.slice(0, 8).toUpperCase();
}

// "10/10/2026 · 20h" (ou "20h30" quando houver minutos).
export function formatarDataHora(iso: string): string {
  const d = new Date(iso);
  const dia = String(d.getDate()).padStart(2, '0');
  const mes = String(d.getMonth() + 1).padStart(2, '0');
  const ano = d.getFullYear();
  const hora = d.getHours();
  const min = d.getMinutes();
  const horario = min > 0 ? `${hora}h${String(min).padStart(2, '0')}` : `${hora}h`;
  return `${dia}/${mes}/${ano} · ${horario}`;
}

// "20h13" — usado na faixa de ingresso já utilizado.
export function formatarHoraMinuto(iso: string): string {
  const d = new Date(iso);
  return `${d.getHours()}h${String(d.getMinutes()).padStart(2, '0')}`;
}

// "10/10/2026 às 20h00" — para o texto do WhatsApp.
export function formatarDataWhats(iso: string): string {
  const d = new Date(iso);
  const dia = String(d.getDate()).padStart(2, '0');
  const mes = String(d.getMonth() + 1).padStart(2, '0');
  const ano = d.getFullYear();
  const hora = d.getHours();
  const min = String(d.getMinutes()).padStart(2, '0');
  return `${dia}/${mes}/${ano} às ${hora}h${min}`;
}